import Button from "components/BaseWidgets/button";
import Tag from "components/BaseWidgets/tag";
import { getFilterData } from "components/Explore/helper";
import { ExploreContext } from "context/ExploreContext";
import React, { useContext, useState } from "react";
import { useLocation, matchPath } from "react-router-dom";
import { retrieveToken } from "utils/storage";

function FilterTags() {
  const userGender = JSON.parse(retrieveToken("user"));
  const gender = userGender?.gender;
  const filterMeta = getFilterData(gender);
  const {
    selectedTags,
    setSelectedTags,
    sliderValues,
    setSliderValues,
    clearAll,
    tabActive,
    selectedList,
  } = useContext(ExploreContext);

  const [showAll, setShowAll] = useState(false);

  // When coming from similar profile listing (More Matches -> Similar matches),
  // hide age and city filter tags from the UI.
  const hideAgeAndCity = tabActive === "7" && selectedList === 4;

  const tagEntries = Object.entries(selectedTags).flatMap(
    ([filterId, tags]) => {
      if (hideAgeAndCity && (filterId === "age" || filterId === "city")) {
        return [];
      }

      return (tags || []).map(({ id, label }) => ({
        key: `${filterId}-${id}`,
        label,
        onClose: () =>
          setSelectedTags((prev) => ({
            ...prev,
            [filterId]: prev[filterId].filter((t) => t.id !== id),
          })),
      }));
    },
  );

  const sliderEntries = Object.entries(sliderValues)
    .flatMap(([filterId, value]) => {
      if (hideAgeAndCity && (filterId === "age" || filterId === "city")) {
        return null;
      }

      const filter = filterMeta.find((item) => item.id === filterId);
      if (!filter || (filter.type !== "slider" && filter.type !== "tags"))
        return null;

      if (filterId === "city" && Array.isArray(value)) {
        return value.map((cityName) => ({
          key: `${filterId}-${cityName}`,
          label: cityName,
          onClose: () =>
            setSliderValues((prev) => {
              const updated = { ...prev };
              updated.city = prev.city.filter((name) => name !== cityName);
              return updated
            }),
        }));
      }
      const [min, max] = Array.isArray(value) ? value : [value, value];
      let unit = "";
      let displayValue = "";

      if (filterId === "height") {
        unit = " Cm";
        displayValue = `${min} - ${max}${unit}`;
      } else if (filterId === "weight") {
        unit = " Kg";
        displayValue = `${min} - ${max}${unit}`;
      } else {
        displayValue = `${min} - ${max} ${filter.label}`;
      }

      return {
        key: filterId,
        label: displayValue,
        onClose: () =>
          setSliderValues((prev) => {
            const updated = { ...prev };
            delete updated[filterId];
            return updated;
          }),
      };
    })
    .filter(Boolean);

  const allTags = [...tagEntries, ...sliderEntries];
  const showTags = showAll ? allTags : allTags.slice(0, 5);
  const hiddenCount = allTags.length - showTags.length;

  const { pathname } = useLocation();
  const isSearchPage = matchPath("/s/:id", pathname);

  if (tabActive !== "1" && !isSearchPage) return null;

  return (
    <>
      {allTags.length > 0 && (
        <div className="flex flex-wrap gap-3 mb-4">
          {showTags.map(({ key, label, onClose }) => (
            <Tag
              key={key}
              className="filter-tag"
              isActive
              variant="selection"
              closable
              onClick={onClose}
            >
              {label}
            </Tag>
          ))}

          {!showAll && hiddenCount > 0 && (
            <Tag
              className="filter-tag counter-tag"
              variant="selection"
              onClick={() => setShowAll(true)}
            >
              +{hiddenCount} more
            </Tag>
          )}

          {showAll && allTags.length > 5 && (
            <Tag
              className="filter-tag counter-tag"
              variant="selection"
              onClick={() => setShowAll(false)}
            >
              Show less
            </Tag>
          )}

          {allTags.length > 1 && (
            <Button
              variant="link"
              onClick={() => {
                clearAll();
                setShowAll(false);
              }}
            >
              Clear all
            </Button>
          )}
        </div>
      )}
    </>
  );
}

export default FilterTags;
